// Datos SEO de municipios canarios para landing pages locales
// Slug: kebab-case en español, sin tildes
import { EXTRA_MUNICIPALITIES } from "./municipalitiesExtra";

export const MUNICIPALITIES = [
  {
    slug: "las-palmas-de-gran-canaria",
    nombre: "Las Palmas de Gran Canaria",
    isla: "Gran Canaria",
    poblacion: "379.925",
    barrios: ["Vegueta", "Triana", "Mesa y López", "La Isleta", "Tamaraceite", "Tafira", "San Cristóbal", "Schamann", "Guanarteme", "Las Canteras", "Siete Palmas", "Jinámar"],
    descripcion_corta: "la capital canaria",
    hero_lede: "Disfruta de fibra óptica FTTH simétrica hasta 1Gb y móvil 5G en toda la capital grancanaria, desde Vegueta hasta Tamaraceite. Red propia, atención local y sin sorpresas.",
    cobertura_pct: 96,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Las Palmas",
  },
  {
    slug: "santa-cruz-de-tenerife",
    nombre: "Santa Cruz de Tenerife",
    isla: "Tenerife",
    poblacion: "207.312",
    barrios: ["Anaga", "Salud-La Salle", "Centro-Ifara", "Ofra-Costa Sur", "Suroeste", "Añaza", "Taganana", "El Tablero", "Los Gladiolos"],
    descripcion_corta: "la capital tinerfeña",
    hero_lede: "Cobertura FTTH y 5G en toda Santa Cruz, desde el centro histórico hasta Anaga. Instalación rápida y tarifas convergentes a precio fijo.",
    cobertura_pct: 94,
    competidores: "Movistar, Vodafone, Orange, MásMóvil",
    centralita_local: "Santa Cruz",
  },
  {
    slug: "la-laguna",
    nombre: "San Cristóbal de La Laguna",
    isla: "Tenerife",
    poblacion: "157.503",
    barrios: ["Tejina", "Bajamar", "Punta del Hidalgo", "La Cuesta", "Taco", "Geneto", "Valle de Guerra", "Las Mercedes"],
    descripcion_corta: "la ciudad universitaria de Tenerife",
    hero_lede: "Fibra simétrica para casa o piso de estudiantes en La Laguna. Activación en 48-72h, sin permanencia y atención 100% canaria.",
    cobertura_pct: 92,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "La Laguna",
  },
  {
    slug: "telde",
    nombre: "Telde",
    isla: "Gran Canaria",
    poblacion: "102.578",
    barrios: ["San Juan", "San Gregorio", "Jinámar", "Las Huesas", "La Garita", "Melenara", "Salinetas", "Tara", "Lomo Magullo"],
    descripcion_corta: "la segunda ciudad de Gran Canaria",
    hero_lede: "Llevamos fibra FTTH a Jinámar, La Garita, San Gregorio y todo Telde. Activamos tu línea en 48-72h con instalación gratuita.",
    cobertura_pct: 90,
    competidores: "Movistar, Vodafone, Orange, Yoigo",
    centralita_local: "Telde",
  },
  {
    slug: "arona",
    nombre: "Arona",
    isla: "Tenerife",
    poblacion: "83.531",
    barrios: ["Los Cristianos", "Las Américas", "Costa del Silencio", "Cabo Blanco", "El Fraile", "Valle San Lorenzo", "Chayofa"],
    descripcion_corta: "el sur turístico de Tenerife",
    hero_lede: "Fibra FTTH y datos móviles para residentes, apartamentos turísticos y negocios en Los Cristianos, Las Américas y todo Arona.",
    cobertura_pct: 88,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Arona",
  },
  {
    slug: "santa-lucia-de-tirajana",
    nombre: "Santa Lucía de Tirajana",
    isla: "Gran Canaria",
    poblacion: "73.736",
    barrios: ["Vecindario", "El Doctoral", "Sardina del Sur", "Pozo Izquierdo", "Santa Lucía Casco"],
    descripcion_corta: "la cuarta ciudad de Gran Canaria",
    hero_lede: "Fibra real en Vecindario, El Doctoral y todo Santa Lucía. Sin penalización, precio fijo y atención canaria 24/7.",
    cobertura_pct: 87,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Vecindario",
  },
  {
    slug: "san-bartolome-de-tirajana",
    nombre: "San Bartolomé de Tirajana",
    isla: "Gran Canaria",
    poblacion: "54.728",
    barrios: ["Maspalomas", "Playa del Inglés", "San Agustín", "Bahía Feliz", "Sonnenland", "Tunte"],
    descripcion_corta: "Maspalomas y la costa sur",
    hero_lede: "Internet de calidad en Maspalomas, Playa del Inglés y todo el sur grancanario. Para tu casa, tu apartamento o tu negocio turístico.",
    cobertura_pct: 85,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Maspalomas",
  },
  {
    slug: "adeje",
    nombre: "Adeje",
    isla: "Tenerife",
    poblacion: "50.493",
    barrios: ["Costa Adeje", "Fañabé", "El Duque", "La Caleta", "Armeñime", "Tijoco", "Los Olivos"],
    descripcion_corta: "Costa Adeje y el sur de Tenerife",
    hero_lede: "Fibra FTTH para residencia o segunda vivienda en Costa Adeje, Fañabé, El Duque y toda Adeje. Activación rápida sin instalador externo.",
    cobertura_pct: 86,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Adeje",
  },

  // ─── Gran Canaria ampliación ───
  {
    slug: "arucas",
    nombre: "Arucas",
    isla: "Gran Canaria",
    poblacion: "38.417",
    barrios: ["Casco", "Bañaderos", "El Puertillo", "Trapiche", "Cardones", "Trasmontaña", "Visvique"],
    descripcion_corta: "la ciudad del ron y las flores",
    hero_lede: "Fibra óptica FTTH en Arucas casco, Bañaderos, El Puertillo, Trapiche y todo el municipio. Sin permanencia y con atención local.",
    cobertura_pct: 89,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Arucas",
  },
  {
    slug: "teror",
    nombre: "Teror",
    isla: "Gran Canaria",
    poblacion: "12.514",
    barrios: ["Casco", "El Palmar", "El Álamo", "El Hornillo", "Miraflor", "San Isidro", "Las Rosadas"],
    descripcion_corta: "la villa mariana de Gran Canaria",
    hero_lede: "Llevamos fibra a las medianías: Teror casco, El Palmar y El Álamo. Donde otros no llegan, LiveWifi sí.",
    cobertura_pct: 76,
    competidores: "Movistar, Orange",
    centralita_local: "Teror",
  },
  {
    slug: "santa-brigida",
    nombre: "Santa Brígida",
    isla: "Gran Canaria",
    poblacion: "18.640",
    barrios: ["Casco", "El Madroñal", "La Atalaya", "Monte Lentiscal", "El Gamonal", "San José de las Vegas"],
    descripcion_corta: "las medianías del centro grancanario",
    hero_lede: "Fibra estable en Santa Brígida, El Madroñal, La Atalaya y Monte Lentiscal, con soporte técnico local.",
    cobertura_pct: 82,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Santa Brígida",
  },
  {
    slug: "galdar",
    nombre: "Gáldar",
    isla: "Gran Canaria",
    poblacion: "24.286",
    barrios: ["Casco", "Sardina del Norte", "El Agujero", "Barrial", "Anzo", "Bocabarranco"],
    descripcion_corta: "la antigua capital aborigen",
    hero_lede: "Fibra FTTH en Gáldar, Sardina del Norte, El Agujero y todo el norte grancanario. Activación en 48-72h.",
    cobertura_pct: 84,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Gáldar",
  },
  {
    slug: "firgas",
    nombre: "Firgas",
    isla: "Gran Canaria",
    poblacion: "7.502",
    barrios: ["Casco", "Buenlugar", "San Andrés", "Rosales", "Casablanca"],
    descripcion_corta: "el municipio del agua en Gran Canaria",
    hero_lede: "Fibra y móvil 5G para hogares en Firgas casco y sus barrios de medianías, sin cortes y con precio fijo.",
    cobertura_pct: 71,
    competidores: "Movistar, Orange",
    centralita_local: "Firgas",
  },
  {
    slug: "moya",
    nombre: "Moya",
    isla: "Gran Canaria",
    poblacion: "7.802",
    barrios: ["Casco", "Fontanales", "Trujillo", "El Altillo", "La Cañada", "Barranco del Laurel"],
    descripcion_corta: "la villa de los Tilos y el bollo de Moya",
    hero_lede: "Fibra FTTH y alternativas WiMax para las medianías: Fontanales, Trujillo y todo Moya. Cobertura donde otros no llegan.",
    cobertura_pct: 64,
    competidores: "Movistar, Orange",
    centralita_local: "Moya",
  },
  {
    slug: "valleseco",
    nombre: "Valleseco",
    isla: "Gran Canaria",
    poblacion: "3.667",
    barrios: ["Casco", "Lanzarote", "Zumacal", "El Rincón", "Valsendero"],
    descripcion_corta: "las cumbres del norte grancanario",
    hero_lede: "Internet estable en las cumbres: Valleseco, Lanzarote (Valleseco) y Valsendero, con fibra o WiMax según zona.",
    cobertura_pct: 58,
    competidores: "Movistar",
    centralita_local: "Valleseco",
  },
  {
    slug: "ingenio",
    nombre: "Ingenio",
    isla: "Gran Canaria",
    poblacion: "31.716",
    barrios: ["Casco", "Carrizal", "El Burrero", "Aguatona", "Los Mocanes", "Las Majoreras"],
    descripcion_corta: "el sureste grancanario",
    hero_lede: "Fibra FTTH y móvil convergente en Ingenio, Carrizal, El Burrero y todo el municipio. Precio fijo, sin sorpresas.",
    cobertura_pct: 88,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Ingenio",
  },
  {
    slug: "aguimes",
    nombre: "Agüimes",
    isla: "Gran Canaria",
    poblacion: "32.269",
    barrios: ["Casco Histórico", "Cruce de Arinaga", "Playa de Arinaga", "El Cruce", "Temisas"],
    descripcion_corta: "un municipio con historia y costa",
    hero_lede: "Cobertura fibra en el casco histórico, Cruce y Playa de Arinaga. Instalación rápida con soporte canario.",
    cobertura_pct: 86,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Agüimes",
  },
  {
    slug: "valsequillo",
    nombre: "Valsequillo de Gran Canaria",
    isla: "Gran Canaria",
    poblacion: "9.264",
    barrios: ["Casco", "El Colmenar", "Tenteniguada", "Las Vegas", "El Rincón"],
    descripcion_corta: "las medianías del sureste",
    hero_lede: "Fibra en el casco de Valsequillo y alternativas WiMax en Tenteniguada y las medianías. Cobertura real, sin promesas vacías.",
    cobertura_pct: 61,
    competidores: "Movistar, Orange",
    centralita_local: "Valsequillo",
  },
  {
    slug: "vega-de-san-mateo",
    nombre: "Vega de San Mateo",
    isla: "Gran Canaria",
    poblacion: "7.578",
    barrios: ["Casco", "La Yedra", "Camaretas", "Utiaca", "Cueva Grande", "Las Lagunetas"],
    descripcion_corta: "el mercado agrícola del centro de la isla",
    hero_lede: "Fibra donde otros no llegan: Vega de San Mateo, La Yedra, Camaretas y todo el municipio. Sin permanencia.",
    cobertura_pct: 67,
    competidores: "Movistar, Orange",
    centralita_local: "San Mateo",
  },
  {
    slug: "mogan",
    nombre: "Mogán",
    isla: "Gran Canaria",
    poblacion: "22.821",
    barrios: ["Puerto de Mogán", "Puerto Rico", "Playa del Cura", "Arguineguín", "Patalavaca", "Anfi del Mar"],
    descripcion_corta: "el sur turístico de Gran Canaria",
    hero_lede: "Fibra FTTH para residentes, apartamentos turísticos y negocios en Puerto de Mogán, Puerto Rico, Arguineguín y todo el municipio.",
    cobertura_pct: 85,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Mogán",
  },
  {
    slug: "la-aldea-de-san-nicolas",
    nombre: "La Aldea de San Nicolás",
    isla: "Gran Canaria",
    poblacion: "7.548",
    barrios: ["Casco", "La Playa", "Tocodomán", "Tasarte", "El Hoyo"],
    descripcion_corta: "el oeste grancanario",
    hero_lede: "Fibra estable en La Aldea casco y La Playa. Precio fijo, atención local y activación 48-72h.",
    cobertura_pct: 70,
    competidores: "Movistar",
    centralita_local: "La Aldea",
  },
  {
    slug: "agaete",
    nombre: "Agaete",
    isla: "Gran Canaria",
    poblacion: "5.706",
    barrios: ["Casco", "Puerto de las Nieves", "El Valle", "El Risco"],
    descripcion_corta: "el noroeste grancanario",
    hero_lede: "Fibra FTTH y alternativas WiMax en Agaete casco, Puerto de las Nieves y El Valle. Soporte canario 24/7.",
    cobertura_pct: 72,
    competidores: "Movistar, Orange",
    centralita_local: "Agaete",
  },

  // ─── Tenerife ampliación ───
  {
    slug: "la-orotava",
    nombre: "La Orotava",
    isla: "Tenerife",
    poblacion: "41.766",
    barrios: ["Casco", "La Perdoma", "San Antonio", "Aguamansa", "Cuesta de la Villa", "Los Realejos-Palo Blanco"],
    descripcion_corta: "el corazón histórico del norte tinerfeño",
    hero_lede: "Fibra FTTH en el casco histórico de La Orotava y sus barrios: La Perdoma, San Antonio y Aguamansa. Sin permanencia.",
    cobertura_pct: 88,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "La Orotava",
  },
  {
    slug: "puerto-de-la-cruz",
    nombre: "Puerto de la Cruz",
    isla: "Tenerife",
    poblacion: "30.088",
    barrios: ["Punta Brava", "La Paz", "El Tejar", "San Fernando", "La Vera", "El Durazno"],
    descripcion_corta: "el destino turístico del norte de Tenerife",
    hero_lede: "Fibra FTTH y datos móviles para hogares y apartamentos turísticos en Puerto de la Cruz, La Paz, Punta Brava y La Vera.",
    cobertura_pct: 91,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Puerto de la Cruz",
  },
  {
    slug: "los-realejos",
    nombre: "Los Realejos",
    isla: "Tenerife",
    poblacion: "37.750",
    barrios: ["Realejo Alto", "Realejo Bajo", "Icod el Alto", "La Cruz Santa", "Palo Blanco", "Toscal-Longuera"],
    descripcion_corta: "el municipio tinerfeño con más fiestas",
    hero_lede: "Fibra estable en Realejo Alto, Realejo Bajo, Icod el Alto y todos los barrios de Los Realejos. Precio fijo.",
    cobertura_pct: 85,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Los Realejos",
  },
  {
    slug: "icod-de-los-vinos",
    nombre: "Icod de los Vinos",
    isla: "Tenerife",
    poblacion: "22.552",
    barrios: ["Casco", "San Marcos", "La Vega", "Buen Paso", "Las Cañas", "Los Piquetes"],
    descripcion_corta: "la villa del drago milenario",
    hero_lede: "Fibra FTTH en Icod casco, San Marcos y todos los pagos. Instalación en 48-72h con atención canaria.",
    cobertura_pct: 82,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Icod",
  },
  {
    slug: "granadilla-de-abona",
    nombre: "Granadilla de Abona",
    isla: "Tenerife",
    poblacion: "52.867",
    barrios: ["El Médano", "San Isidro", "Los Abrigos", "Chimiche", "Charco del Pino", "Granadilla casco"],
    descripcion_corta: "el sur productivo de Tenerife",
    hero_lede: "Fibra FTTH en El Médano, San Isidro, Los Abrigos y todo Granadilla. Ideal para nómadas digitales y residentes.",
    cobertura_pct: 89,
    competidores: "Movistar, Vodafone, Orange, MásMóvil",
    centralita_local: "Granadilla",
  },
  {
    slug: "guia-de-isora",
    nombre: "Guía de Isora",
    isla: "Tenerife",
    poblacion: "20.938",
    barrios: ["Casco", "Alcalá", "Playa San Juan", "Chío", "Vera de Erques", "Tejina"],
    descripcion_corta: "la costa suroeste tinerfeña",
    hero_lede: "Fibra en Playa San Juan, Alcalá y Guía de Isora casco. Cobertura FTTH y móvil para hogares y negocios costeros.",
    cobertura_pct: 83,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Guía de Isora",
  },
  {
    slug: "candelaria",
    nombre: "Candelaria",
    isla: "Tenerife",
    poblacion: "28.209",
    barrios: ["Casco", "Las Caletillas", "Barranco Hondo", "Igueste", "Punta Larga"],
    descripcion_corta: "la villa mariana tinerfeña",
    hero_lede: "Fibra FTTH en Candelaria, Las Caletillas y Barranco Hondo. Precio fijo con IGIC incluido.",
    cobertura_pct: 86,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Candelaria",
  },
  {
    slug: "tacoronte",
    nombre: "Tacoronte",
    isla: "Tenerife",
    poblacion: "23.917",
    barrios: ["Casco", "Los Naranjeros", "Guayonge", "Mesa del Mar", "El Pris", "Barranco Las Lajas"],
    descripcion_corta: "el corredor vinícola del norte",
    hero_lede: "Fibra estable en Tacoronte, Los Naranjeros, Mesa del Mar y todo el término. Soporte técnico local.",
    cobertura_pct: 84,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Tacoronte",
  },
  {
    slug: "el-sauzal",
    nombre: "El Sauzal",
    isla: "Tenerife",
    poblacion: "9.020",
    barrios: ["Casco", "La Baranda", "El Ravelo", "San Nicolás", "Los Ángeles"],
    descripcion_corta: "el mirador del norte tinerfeño",
    hero_lede: "Fibra FTTH en El Sauzal casco, La Baranda y El Ravelo. Cobertura donde antes solo llegaba ADSL.",
    cobertura_pct: 79,
    competidores: "Movistar, Orange",
    centralita_local: "El Sauzal",
  },

  // ─── Lanzarote ───
  {
    slug: "arrecife",
    nombre: "Arrecife",
    isla: "Lanzarote",
    poblacion: "63.020",
    barrios: ["Titerroy", "Argana Alta", "Argana Baja", "Valterra", "Los Alonsos", "El Cable", "Playa Honda"],
    descripcion_corta: "la capital conejera",
    hero_lede: "Fibra FTTH en toda la capital lanzaroteña: Titerroy, Argana, Valterra, Playa Honda y más. Sin permanencia.",
    cobertura_pct: 91,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Arrecife",
  },
  {
    slug: "tias",
    nombre: "Tías",
    isla: "Lanzarote",
    poblacion: "20.098",
    barrios: ["Puerto del Carmen", "Casco", "Puerto Calero", "Mácher", "La Asomada", "Conil"],
    descripcion_corta: "el turismo lanzaroteño por excelencia",
    hero_lede: "Fibra FTTH en Puerto del Carmen, Puerto Calero, Tías casco y Mácher. Ideal para apartamentos y negocios turísticos.",
    cobertura_pct: 88,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Tías",
  },
  {
    slug: "teguise",
    nombre: "Teguise",
    isla: "Lanzarote",
    poblacion: "23.478",
    barrios: ["Costa Teguise", "Villa de Teguise", "Nazaret", "Tahíche", "Los Cocoteros", "Guatiza"],
    descripcion_corta: "la antigua capital lanzaroteña",
    hero_lede: "Fibra en Costa Teguise, Villa de Teguise y todo el municipio. Activación en 48-72h y precio fijo.",
    cobertura_pct: 84,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Teguise",
  },
  {
    slug: "san-bartolome-lanzarote",
    nombre: "San Bartolomé",
    isla: "Lanzarote",
    poblacion: "18.951",
    barrios: ["Casco", "Playa Honda", "Güime", "Mozaga", "El Islote", "Argana Alta"],
    descripcion_corta: "el corazón lanzaroteño",
    hero_lede: "Fibra FTTH en San Bartolomé, Playa Honda, Güime y todo el municipio. Sin permanencia.",
    cobertura_pct: 87,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "San Bartolomé",
  },
  {
    slug: "yaiza",
    nombre: "Yaiza",
    isla: "Lanzarote",
    poblacion: "17.146",
    barrios: ["Playa Blanca", "Casco", "Uga", "La Hoya", "Femés"],
    descripcion_corta: "el sur lanzaroteño",
    hero_lede: "Fibra FTTH en Playa Blanca, Yaiza casco y Uga. Cobertura para residentes y sector turístico.",
    cobertura_pct: 82,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Yaiza",
  },

  // ─── Fuerteventura ───
  {
    slug: "puerto-del-rosario",
    nombre: "Puerto del Rosario",
    isla: "Fuerteventura",
    poblacion: "42.106",
    barrios: ["Casco", "El Charco", "Buenavista", "Los Pozos", "La Charca", "Playa Blanca", "Rosa Vila"],
    descripcion_corta: "la capital majorera",
    hero_lede: "Fibra FTTH en toda la capital de Fuerteventura: El Charco, Buenavista, Los Pozos y más. Sin permanencia.",
    cobertura_pct: 88,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Puerto del Rosario",
  },
  {
    slug: "la-oliva",
    nombre: "La Oliva",
    isla: "Fuerteventura",
    poblacion: "27.732",
    barrios: ["Corralejo", "Casco", "El Cotillo", "Villaverde", "Lajares", "Parque Holandés"],
    descripcion_corta: "el norte majorero (Corralejo y El Cotillo)",
    hero_lede: "Fibra FTTH en Corralejo, El Cotillo, Lajares y La Oliva casco. Ideal para nómadas digitales y hogares.",
    cobertura_pct: 85,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Corralejo",
  },
  {
    slug: "antigua",
    nombre: "Antigua",
    isla: "Fuerteventura",
    poblacion: "12.144",
    barrios: ["Casco", "Caleta de Fuste", "El Castillo", "Costa Antigua", "Triquivijate"],
    descripcion_corta: "la costa este majorera",
    hero_lede: "Fibra FTTH en Caleta de Fuste, El Castillo, Costa Antigua y todo Antigua. Sin sorpresas en la factura.",
    cobertura_pct: 84,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Antigua",
  },
  {
    slug: "pajara",
    nombre: "Pájara",
    isla: "Fuerteventura",
    poblacion: "20.867",
    barrios: ["Morro Jable", "Costa Calma", "La Lajita", "Solana Matorral", "Pájara casco"],
    descripcion_corta: "el sur turístico majorero (Morro Jable y Costa Calma)",
    hero_lede: "Fibra FTTH en Morro Jable, Costa Calma, La Lajita y todo Pájara. Cobertura para residentes y turistas.",
    cobertura_pct: 80,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Pájara",
  },

  // ─── La Palma ───
  {
    slug: "santa-cruz-de-la-palma",
    nombre: "Santa Cruz de La Palma",
    isla: "La Palma",
    poblacion: "15.716",
    barrios: ["Casco Histórico", "La Encarnación", "San Telmo", "La Portada", "Mirca", "Puerto"],
    descripcion_corta: "la capital palmera",
    hero_lede: "Fibra FTTH en el casco histórico, La Encarnación y toda la capital de La Palma. Instalación rápida.",
    cobertura_pct: 82,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Santa Cruz de La Palma",
  },
  {
    slug: "los-llanos-de-aridane",
    nombre: "Los Llanos de Aridane",
    isla: "La Palma",
    poblacion: "20.212",
    barrios: ["Casco", "Argual", "Tazacorte-Los Llanos", "El Paso-linde", "Todoque", "La Laguna"],
    descripcion_corta: "el corazón económico de La Palma",
    hero_lede: "Fibra FTTH en Los Llanos casco, Argual y todo el término. Alternativas WiMax en zonas afectadas por el volcán.",
    cobertura_pct: 78,
    competidores: "Movistar, Vodafone, Orange",
    centralita_local: "Los Llanos",
  },
  {
    slug: "el-paso",
    nombre: "El Paso",
    isla: "La Palma",
    poblacion: "7.646",
    barrios: ["Casco", "Tacande", "Las Manchas", "Los Campitos", "Todoque-linde"],
    descripcion_corta: "la puerta al Roque de los Muchachos",
    hero_lede: "Fibra y WiMax para el casco de El Paso y las medianías. Cobertura estable en zonas montañosas.",
    cobertura_pct: 68,
    competidores: "Movistar, Orange",
    centralita_local: "El Paso",
  },
];

MUNICIPALITIES.push(...EXTRA_MUNICIPALITIES);

export const findMunicipality = (slug) => MUNICIPALITIES.find((m) => m.slug === slug) || null;
